<script>
export default {
    
}
</script>

<template>
    <div class="statement">
        <!-- <p>提交后会有4S店为您提供报价方案</p> -->
        <p class="tip">提交后会有4S店为您提供报价方案</p>
        <p>
            点击即视为同意
            <a href="https://dealer.m.autohome.com.cn/dealer/agreement.html">《个人信息保护声明》</a>
        </p>
    </div>
</template>
<style lang="stylus" scoped>
.statement
    margin 0.8rem 0;
    font-size 0
    text-align center
    p
        display inline-block
        font-size 0.533rem
        color #666
    .tip
        margin-bottom .3rem
    a
        display inline-block
        margin 0
        font-size 0.533rem
        font-weight normal
        color #4b76f6
        text-decoration none
</style>
